import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ApiService } from '@services/api.service';
import { environment } from '@env/environment';

import { BrokerMessageModel, SendBrokerMessageModel } from '@data-layer/models/entry-summaries';

@Injectable({
  providedIn: 'root',
})
export class BrokerMessagesRepository {
  constructor(private apiService: ApiService) {}

  public getMessages(entrySummaryId: number, isShowLoader: boolean = true, isUsed: boolean = false): Observable<BrokerMessageModel[]> {
    return this.apiService.get<BrokerMessageModel[]>(
      `${environment.url.prefixCustoms}v2/entry-summaries/${entrySummaryId}/messages`,
      null,
      {
        isShowLoader,
        isUsed,
      },
    );
  }

  public markAsRead(entrySummaryId: number, value: boolean = false, isShowLoader: boolean = true): Observable<any> {
    return this.apiService.put<any>(
      `${environment.url.prefixCustoms}v2/entry-summaries/${entrySummaryId}/hasNewBrokerMessages`,
      value,
      null,
      {
        isShowLoader,
      },
    );
  }

  /** The text travels in the body (`SendBrokerMessageModel`); the legacy `?content=` query is deprecated on the backend. */
  public createMessage(entrySummaryId: number, content: string): Observable<never> {
    const body: SendBrokerMessageModel = { content };
    return this.apiService.post(`${environment.url.prefixCustoms}v2/entry-summaries/${entrySummaryId}/messages`, body);
  }
}
